import { ProgramRegistrationFormData } from './types';

export const DefaultProgramRegistrationFormData: ProgramRegistrationFormData = {
  usecase: {
    brandUid: '',
    brandName: '',
    usecase: '',
  },
  routing: {
    routingMode: '',
    offNetOutboundTerminationSupported: undefined,
    intlInboundTerminationSupported: undefined,
    intlOutboundTerminationSupported: undefined,
    onNetInboundTerminationSupported: undefined,
    offNetInboundTerminationSupported: undefined,
    upstreamCnpUid: '',
    mnoIds: [],
  },
  details: {
    description: '',
    referenceId: '',
    expectedMessageVolume: '',
    supportingDocumentUuid: [],
    sampleMessages: [{ message: '' }],
    embeddedLink: undefined,
    embeddedLinkSample: '',
    embeddedPhone: undefined,
  },
  ui: {
    selectedUseCaseMetadata: null,
    mnoNetworks: [],
    brandUseCases: [],
    usecaseDisplayName: '',
  },
};
